import React, { useEffect, useState } from 'react';
import { format } from 'date-fns';
import { FileItemLayout, Image, Button, Tooltip } from '../../../../../../ui';
import { IconTrash } from '../../../../../../ui/Icons';
import FileTypeIcon from '../../../../../../ui/Icons/FileTypeIcons/FileTypeIcon';

const {
  ThumbnailWrapper,
  ListItemWrapper,
  ListItemInfoWrapper,
  FileInfoWrapper,
  FileSize,
  FileUploadDate,
  FileUploadDateMobile,
  FileSizeWrapper,
  ButtonsWrapper,
  FileNameWrapper,
  FileName,
  FileExtension
} = FileItemLayout;

const FILENAME_MAX_CHARACTER_LENGTH = 20;
// shorten file name if it's too long
function formatMessageBlobFileName(fileName) {
  if (fileName.length > FILENAME_MAX_CHARACTER_LENGTH) {
    return `${fileName.slice(0, FILENAME_MAX_CHARACTER_LENGTH)}...`;
  }

  return fileName;
}

export const CreateMessageAddAttachmentsUploadedFileItem = React.memo(
  ({ file, handleRemove, withBackground = false }) => {
    const [preview, setPreview] = useState();

    useEffect(() => {
      const { blob } = file || {};
      // create the preview
      const objectUrl = URL.createObjectURL(blob);
      setPreview(objectUrl);
      // free memory when ever this component is unmounted
      return () => URL.revokeObjectURL(objectUrl);
    }, [file]);

    const handleOnRemoveClick = () => {
      handleRemove();
    };

    const getThumbnail = () => {
      const { type = '' } = blob || {};
      if (type.includes('image')) {
        return <Image src={preview} className="details-page-files-image" alt={file.filename} preview={false} />;
      }

      return <FileTypeIcon type={fileType} />;
    };

    // files do not have a uploaded date, so we use the current date
    const { blob } = file;
    const blobMimeType = blob?.type || '';
    const blobExtensionLower = blob?.name?.split('.').pop()?.toLowerCase();
    const blobIsSpreadsheetMime = blobMimeType.includes('spreadsheetml.sheet');
    const blobIsXlsxExtension = blobExtensionLower === 'xlsx';
    const fileSizeInMb = (blob.size / 1048576).toFixed(2);
    const fileType = blobIsSpreadsheetMime || blobIsXlsxExtension ? 'xlsx' : blobMimeType.split('/')?.[1];
    const fileName = blob.name.substring(0, blob.name.lastIndexOf('.'));
    const shortFileName = formatMessageBlobFileName(fileName);
    const fileExtension = blob.name.substring(blob.name.lastIndexOf('.') + 1);
    const createdAt = format(new Date(), "'Hinzugefügt am ' dd.MM.yyyy 'um' HH:mm 'Uhr'");
    const createdAtMobile = format(new Date(), 'dd.MM.yyyy');

    return (
      <ListItemWrapper
        key={blob.lastModified}
        className="attachments-modal-list-item uploaded-file-item"
        $withBackground={withBackground}
      >
        <ListItemInfoWrapper>
          <ThumbnailWrapper>{getThumbnail()}</ThumbnailWrapper>
          <FileInfoWrapper>
            <FileNameWrapper>
              <FileName>
                <Tooltip title={blob.name}>{`${shortFileName}.`}</Tooltip>
              </FileName>
              <FileExtension>{fileExtension}</FileExtension>
            </FileNameWrapper>
            <FileSizeWrapper>
              <FileSize>{`${fileSizeInMb} MB`}</FileSize>
              <FileUploadDate>{createdAt}</FileUploadDate>
              <FileUploadDateMobile>{createdAtMobile}</FileUploadDateMobile>
            </FileSizeWrapper>
          </FileInfoWrapper>
          <ButtonsWrapper>
            <Button type="link" onClick={handleOnRemoveClick} icon={<IconTrash />} danger />
          </ButtonsWrapper>
        </ListItemInfoWrapper>
      </ListItemWrapper>
    );
  }
);
